<template>
  <app-no-menu-layout>
    <template v-if="configReady && dataReady">
      <v-layout wrap>
        <v-flex md12>
          <template>
            <opendata-checklist-form
              :form-config="config.checklistForm"
              :entity="initialData"
            ></opendata-checklist-form>
          </template>
        </v-flex>
      </v-layout>
    </template>

    <router-view></router-view>
  </app-no-menu-layout>
</template>
<script>
import AppNoMenuLayout from '@/views/layouts/AppNoMenuLayout.vue';
import OpendataChecklistForm from '../components/OpendataChecklistForm';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AppNoMenuLayout,

    OpendataChecklistForm,
  },
  props: {
    id: {
      type: [String, Number],
    },
    step: {
      type: String,
    },
  },
  data() {
    return {
      config: {},
      initialData: null,
      configReady: false,
      dataReady: false,
    };
  },
  mounted() {
    console.log({ ID: this.id });
    this.getConfig();
    if (this.id !== 'new') {
      this.getFormData();
    } else {
      this.dataReady = true;
    }
  },
  methods: {
    getFormData() {
      this.dataReady = false;
      apiCtrl.get('/opendata-form/' + this.id).then(res => {
        this.initialData = res.data.data;
        this.dataReady = true;
      });
    },
    getConfig() {
      this.configReady = false;
      apiCtrl.get('/config/opendata').then(res => {
        this.config = res.data.data;
        this.configReady = true;
      });
    },
  },
};
</script>
